import React, { useState } from 'react';

import styled from '@emotion/styled';

import PrimaryButton from '../../components/Button/PrimaryButton';
import LogoHeader from '../../components/LogoHeader/LogoHeader';
import Page from '../../components/Page/Page';
import { formatNaira } from '../../utils/utils';
import DeliveryDateForm from './DeliveryDateForm';

const packageItems = [
  {
    name: 'Nike Air Max Limited Edition By Yemo of Niaja',
    price: 106000,
  },
  {
    name: 'Nike Air Micro Idumota Boy and Yemoly Nike Air Micro Idumota Boy and Yemoly',
    price: 106000,
  },
  {
    name: 'Nike Air Max Limited Edition',
    price: 106000,
  },
  {
    name: 'Nike Air Max Limited Edition',
    price: 106000,
  },
];

const Invoice = () => {
  const [isDisabled, setIsDisabled] = useState(true);

  return (
    <Page title="Darum | Invoice">
      <Container>
        <LogoHeader />
        <Content>
          <WelcomeArea>
            <Heading>Package #000001</Heading>
            <Description>
              Hello, <b>ajoritsedere@gmail.com</b> Here is your package summary.
              Please review and continue to check out your package from the
              warehouse.
            </Description>
          </WelcomeArea>
          <ButtonArea>
            <PrimaryButton arrowIcon disabled={isDisabled}>
              Proceed to Pay
            </PrimaryButton>
          </ButtonArea>
          <AddressArea>
            <p>From</p>
            <p className="address">
              9159 Fletcher Landing Apt. 884, Moreno Valley, Massachusetts,
              61947
              <br />
              <b>Amazon</b>
            </p>
            <p>To</p>
            <p className="address">
              59762 Hassie Light Suite 472, Peabody, Virginia, LC24 5GY
              <br />
              <b>Ajoritsedere Rone-Orugboh</b>
            </p>
          </AddressArea>
          <EstimatedDeliveryDate>
            <p className="mobile-margin">Received by Darum</p>
            <p className="date mobile-margin">20th November 2023</p>
            {/* <p>Expected Delivery Date</p> */}
            {/* <p className="date">31st November 2023</p> */}
            <div>
              <DeliveryDateForm setIsDisabled={setIsDisabled} />
            </div>
          </EstimatedDeliveryDate>
          <ItemsInPackage>
            <Header2>Items in Package ({packageItems.length})</Header2>
            <ItemArea>
              {packageItems.map((itemProp, index) => (
                <Item key={index}>
                  <ItemContentWrapper>
                    <p>{itemProp.name}</p>
                    <p className="currency">{formatNaira(itemProp.price)}</p>
                  </ItemContentWrapper>
                </Item>
              ))}
            </ItemArea>
          </ItemsInPackage>
          <PackageSummary>
            <Header2>Package Summary</Header2>
            <CostBreakDown>
              <p>Subtotal</p>
              <p className="currency">{formatNaira(106000)}</p>

              <p>Last Mile fee and clearance</p>
              <p className="currency">{formatNaira(18000)}</p>
            </CostBreakDown>
            <TotalCostBox>
              <p>Total:</p>
              <p className="currency">{formatNaira(124400)}</p>
            </TotalCostBox>
          </PackageSummary>
        </Content>
      </Container>
    </Page>
  );
};

export default Invoice;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: auto;
`;

const Content = styled.div`
  display: grid;
  grid-template-columns: 6fr 4fr;
  gap: 2.56rem;
  margin: 2rem 3.75rem 8rem 3.75rem;
  /* outline: 2px solid red; */

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    margin: 3.75rem 1.25rem;
  }
`;

const WelcomeArea = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const Heading = styled.h1`
  font-size: 2rem;
  font-weight: 600;
  color: black;
`;

const Description = styled.p`
  font-size: 1.25rem;
  font-weight: 400;

  @media (max-width: 480px) {
    font-size: 1rem;
  }
`;

const ButtonArea = styled.div`
  display: flex;
  align-items: flex-end;
  flex-direction: row-reverse;
  /* border: 2px solid yellow; */

  @media (max-width: 480px) {
    grid-row: 6;
    flex-direction: row;

    & > * {
      width: 100%;
    }
  }
`;

const AddressArea = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.borderColor};
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 2rem;
  font-size: 1rem;
  font-weight: 400;
  padding: 1.06rem 0;

  & > p.address {
    width: 65%;
    margin-left: 2rem;

    @media (max-width: 480px) {
      width: 90%;
    }
  }
`;

const EstimatedDeliveryDate = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.borderColor};
  display: grid;
  grid-template-columns: 1fr 1fr;
  font-size: 1rem;
  font-weight: 400;
  padding: 1.06rem 0;

  & > p.date {
    font-weight: 500;
    text-align: right;
  }

  & > div {
    grid-column: span 2;
    margin-top: 3rem;
  }

  @media (max-width: 480px) {
    & > p.mobile-margin {
      margin-bottom: 3.87rem;
    }

    & > div {
      margin-top: 0rem;
    }
  }
`;

const ItemsInPackage = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 1.06rem 0;
  display: flex;
  flex-direction: column;
  gap: 2rem;

  @media (max-width: 480px) {
    grid-row: 3;
  }
`;

const Header2 = styled.h2`
  font-size: 1.5rem;
`;

const ItemArea = styled.ul`
  list-style: none;
  counter-reset: my-counter;
  padding: 0;

  display: flex;
  flex-direction: column;
  gap: 2.88rem;

  height: 240px;
  /* border: 1px solid yellow; */
  overflow: auto;

  @media (max-width: 480px) {
    gap: 2.25rem;
  }
`;

const Item = styled.li`
  counter-increment: my-counter;
  position: relative;
  padding-left: 3rem;
  font-size: 1.25rem;
  font-weight: 400;
  width: 90%;

  @media (max-width: 480px) {
    width: 100%;
    font-size: 1rem;
  }

  /* border: 2px solid red; */

  &:before {
    content: '0' counter(my-counter);
    position: absolute;
    left: 0;
  }
`;

const ItemContentWrapper = styled.div`
  display: flex;
  justify-content: space-between;

  & > p.currency {
    font-weight: 700;
    font-size: 1.5rem;
    margin-top: -0.1rem;

    @media (max-width: 480px) {
      font-size: 1.25rem;
    }
  }
`;

const PackageSummary = styled.div`
  border-top: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 1.06rem 0;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const CostBreakDown = styled.div`
  display: grid;
  grid-template-columns: 1fr auto;
  gap: 2.62rem;
  font-size: 1.25rem;
  font-weight: 400;

  @media (max-width: 480px) {
    font-size: 1rem;
  }

  & > p.currency {
    font-weight: 700;
    font-size: 1.5rem;
    margin-top: -0.1rem;
    text-align: right;

    @media (max-width: 480px) {
      font-size: 1.25rem;
    }
  }
`;

const TotalCostBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 1.5rem;
  background-color: ${({ theme }) => theme.palette.primaryShades1};
  font-size: 1.25rem;
  font-weight: 600;
  border-radius: 0.25rem;

  @media (max-width: 480px) {
    font-size: 1rem;
  }

  & > p.currency {
    font-weight: 700;
    font-size: 2rem;
    margin-top: -0.1rem;
    text-align: right;
    color: ${({ theme }) => theme.palette.primaryFocused};

    @media (max-width: 480px) {
      font-size: 1.5rem;
    }
  }
`;
